<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">

        <h2 class="brand-text text-primary ml-1">
          Fenomany
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Forgot password V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Forgot password-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            Şifremi Unuttum? 🔒
          </b-card-title>
          <b-card-text class="mb-2">
            E-postanızı girin, şifrenizi sıfırlamanız için size talimatlar gönderelim
          </b-card-text>

          <!-- form -->
          <validation-observer ref="simpleRules">
            <b-form
              class="auth-forgot-password-form mt-2"
              @submit.prevent="validationForm"
            >
              <b-form-group
                label="Email"
                label-for="email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="email"
                    v-model="email"
                    :state="errors.length > 0 ? false:null"
                    name="email"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-button
                type="submit"
                variant="primary"
                block
              >
                Yenileme bağlantısı gönder
              </b-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <b-link :to="{name:'login'}">
              <feather-icon icon="ChevronLeftIcon" /> Giriş sayfasına dön
            </b-link>
          </p>
        </b-col>
      </b-col>
      <!-- /Forgot password-->
    </b-row>
    <b-modal
      v-model="modalShow"
      title="İşlem yapacağınız firmayı seçiniz"
      centered 
      hide-footer
      modal-class="modal-success" 
    >
      <div class="row justify-content-center">
        <div class="px-2 py-1" v-for="customer in customerList" :key="customer" @click="selectCustomer(customer)">
            <b-button variant="gradient-danger">{{ customer.domain }}</b-button>
        </div>
      </div>
    </b-modal>
  </div>
  
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BCardTitle, BCardText, BImg, BForm, BFormGroup, BFormInput, BButton, BModal
} from 'bootstrap-vue'
import { required, email } from '@validations'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    VuexyLogo,
    BRow,
    BCol,
    BLink,
    BImg,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BCardTitle,
    BCardText,
    ValidationProvider,
    ValidationObserver,
    BModal
  },
  data() {
    return {
      sideImg: require('@/assets/images/pages/forgot-password-v2.svg'),
      // validation
      required,
      email,
      modalShow:false,
      customerList:[]
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/forgot-password-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    selectCustomer(customer) {
      this.modalShow = false; // Modalı kapat
      this.$store.commit('user/SET_CUSTOMER', customer);
      this.postForgot()
    },
    
    validationForm() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          this.postForgot()
        }
      })
    },
    async postForgot(){
      const payload = {
          email: this.email,
          multilogin: true,
          user_type:this.$route.params.type
        }
        const endpoint = '/auth/forgot-password';
        try {
          const response = await this.$http.post(endpoint, payload, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
            if (response.data.success) {
              this.$router.push({ name: 'login' })
              .then(() => {
                this.$toast({
                component: ToastificationContent,
                props: {
                  title: response.data.message,
                  icon: 'CheckIcon',
                  variant: 'success',
                },
              })
              });
              this.$store.commit('user/SET_CUSTOMER', null);
            }else if(response.data.selectCustomer){
              this.modalShow=true
              this.customerList=response.data.customers
            } else {
            this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.error,
              icon: 'EditIcon',
              variant: 'danger',
            },
            })
          }
        } catch (error) {
          console.error('Error:', error);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error,
              icon: 'EditIcon',
              variant: 'danger',
            },
          })
        }
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
